"use strict";

import angular from "angular";

import { colorsChartTheme2 } from "./colors-charts/colors-charts-theme2";
import { colorsChartTheme3 } from "./colors-charts/colors-charts-theme3";
import { colorsChartTheme4 } from "./colors-charts/colors-charts-theme4";
import { colorsChartTheme5 } from "./colors-charts/colors-charts-theme5";
import { colorsChartTheme6 } from "./colors-charts/colors-charts-theme6";
import { colorsChartTheme7 } from "./colors-charts/colors-charts-theme7";
import { colorsChartDefault } from "./colors-charts/colors-charts-default";

export class ThemesService {
    constructor($rootScope) {
        this.$rootScope = $rootScope;

        this.currentTheme = "";
        this.currentDashboardTheme = "";

        this.classThemes = {
            dark: { old: "dsn-dark-mode", new: "theme-dark" },
            light: { old: "dsn-light-mode", new: "theme-light" }
        };
        this.dashboardsThemes = {
            default: colorsChartDefault,
            theme2: colorsChartTheme2,
            theme3: colorsChartTheme3,
            theme4: colorsChartTheme4,
            theme5: colorsChartTheme5,
            theme6: colorsChartTheme6,
            theme7: colorsChartTheme7
        };
    }

    setTheme(theme) {
        if (this.currentTheme)
            document.body.classList.remove(
                this.classThemes[this.currentTheme].old
            );
        document.body.classList.add(this.classThemes[theme].old);
        if (this.currentTheme)
            document.documentElement.classList.remove(
                this.classThemes[this.currentTheme].new
            );
        document.documentElement.classList.add(this.classThemes[theme].new);
        this.setCurrentTheme(theme);
        return theme;
    }

    setCurrentTheme(theme) {
        this.currentTheme = theme;

        this._emitEvent(theme);
    }

    getTheme() {
        return this.currentTheme;
    }

    _emitEvent(theme) {
        this.$rootScope.$broadcast("THEMES_SERVICE_THEME_CHANGED", theme);
    }
    setCurrentDashboardTheme(theme) {
        this.currentDashboardTheme = theme;
    }
    getCurrentDashboardTheme() {
        return this.currentDashboardTheme;
    }
    getDashboardTheme(theme = this.currentDashboardTheme) {
        return this.dashboardsThemes[theme];
    }
    setDashboardTheme(theme) {
        this.setCurrentDashboardTheme(theme);
        this._emitEvent(theme);
    }
}

angular.module("nucont.shared").service("ThemesService", ["$rootScope", ThemesService]);
